// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#data-highlights-topmenu[data-v-36e9d01f]{cursor:text}.nuxt-link-exact-active[data-v-36e9d01f]{font-weight:700}.logo[data-v-36e9d01f]{display:block;width:225px}", ""]);
// Exports
module.exports = exports;
